import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    loading: false,
    error: {},
    alert: {},
    modalAlert: {},
    pusher: null,
    configs: {},
    recaptchaKey: '6LcfDSIeAAAAAIPgzZJb1uej6P1o7BMlobTJ2sdu',
    backdrop: false,
    menuNavOpen: false,
  },
  actions,
  getters,
  mutations,
};